export const FETCH_USERS_REQUEST = 'FETCH_USERS_REQUEST';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILED = 'FETCH_USERS_FAILED';

export const FETCH_CREATE_USER_REQUEST = 'FETCH_CREATE_USER_REQUEST';
export const FETCH_CREATE_USER_SUCCESS = 'FETCH_CREATE_USER_SUCCESS';
export const FETCH_CREATE_USER_FAILED = 'FETCH_CREATE_USER_FAILED';

export const FETCH_USERS_STATUS_REQUEST = 'FETCH_USERS_STATUS_REQUEST';
export const FETCH_USERS_STATUS_SUCCESS = 'FETCH_USERS_STATUS_SUCCESS';
export const FETCH_USERS_STATUS_FAILED = 'FETCH_USERS_STATUS_FAILED';

export const FETCH_USER_BY_ID_REQUEST = 'FETCH_USER_BY_ID_REQUEST';
export const FETCH_USER_BY_ID_SUCCESS = 'FETCH_USER_BY_ID_SUCCESS';
export const FETCH_USER_BY_ID_FAILED = 'FETCH_USER_BY_ID_FAILED';
export const RESET_USER = 'RESET_USER';

export const FETCH_USER_INFO_ACTION_REQUEST = 'FETCH_USER_INFO_ACTION_REQUEST';
export const FETCH_USER_INFO_ACTION_SUCCESS = 'FETCH_USER_INFO_ACTION_SUCCESS';
export const FETCH_USER_INFO_ACTION_FAILED = 'FETCH_USER_INFO_ACTION_FAILED';

export const FETCH_UPDATE_USER_REQUEST = 'FETCH_UPDATE_USER_REQUEST';
export const FETCH_UPDATE_USER_SUCCESS = 'FETCH_UPDATE_USER_SUCCESS';
export const FETCH_UPDATE_USER_FAILED = 'FETCH_UPDATE_USER_FAILED';

export const FETCH_DELETE_USER_REQUEST = 'FETCH_DELETE_USER_REQUEST';
export const FETCH_DELETE_USER_SUCCESS = 'FETCH_DELETE_USER_SUCCESS';
export const FETCH_DELETE_USER_FAILED = 'FETCH_DELETE_USER_FAILED';
export const RESET_DELETE_USER_SUCCESS = 'RESET_DELETE_USER_SUCCESS';

export const FETCH_UPDATE_USER_QUALIFICATIONS_REQUEST = 'FETCH_UPDATE_USER_QUALIFICATIONS_REQUEST';
export const FETCH_UPDATE_USER_QUALIFICATIONS_SUCCESS = 'FETCH_UPDATE_USER_QUALIFICATIONS_SUCCESS';
export const FETCH_UPDATE_USER_QUALIFICATIONS_FAILED = 'FETCH_UPDATE_USER_QUALIFICATIONS_FAILED';

export const FETCH_UPDATE_USER_STATUS_REQUEST = 'FETCH_UPDATE_USER_STATUS_REQUEST';
export const FETCH_UPDATE_USER_STATUS_SUCCESS = 'FETCH_UPDATE_USER_STATUS_SUCCESS';
export const FETCH_UPDATE_USER_STATUS_FAILED = 'FETCH_UPDATE_USER_STATUS_FAILED';

export const FETCH_RESET_UPDATE_USER_STATUS = 'FETCH_RESET_UPDATE_USER_STATUS';

export const FETCH_UPDATE_USER_ROLE_REQUEST = 'FETCH_UPDATE_USER_ROLE_REQUEST';
export const FETCH_UPDATE_USER_ROLE_SUCCESS = 'FETCH_UPDATE_USER_ROLE_SUCCESS';
export const FETCH_UPDATE_USER_ROLE_FAILED = 'FETCH_UPDATE_USER_ROLE_FAILED';

export const FETCH_RESET_UPDATE_USER_ROLE = 'FETCH_RESET_UPDATE_USER_ROLE';

export const FETCH_ADD_USER_VEHICLE_GROUPS_REQUEST = 'FETCH_ADD_USER_VEHICLE_GROUPS_REQUEST';
export const FETCH_ADD_USER_VEHICLE_GROUPS_SUCCESS = 'FETCH_ADD_USER_VEHICLE_GROUPS_SUCCESS';
export const FETCH_ADD_USER_VEHICLE_GROUPS_FAILED = 'FETCH_ADD_USER_VEHICLE_GROUPS_FAILED';

export const FETCH_DELETE_USER_VEHICLE_GROUPS_REQUEST = 'FETCH_DELETE_USER_VEHICLE_GROUPS_REQUEST';
export const FETCH_DELETE_USER_VEHICLE_GROUPS_SUCCESS = 'FETCH_DELETE_USER_VEHICLE_GROUPS_SUCCESS';
export const FETCH_DELETE_USER_VEHICLE_GROUPS_FAILED = 'FETCH_DELETE_USER_VEHICLE_GROUPS_FAILED';
export const RESET_UPDATE_USER_SUCCESS = 'RESET_UPDATE_USER_SUCCESS';

export const FETCH_USERS_PRIVILEGES_REQUEST = 'FETCH_USERS_PRIVILEGES_REQUEST';
export const FETCH_USERS_PRIVILEGES_SUCCESS = 'FETCH_USERS_PRIVILEGES_SUCCESS';
export const FETCH_USERS_PRIVILEGES_FAILURE = 'FETCH_USERS_PRIVILEGES_FAILURE';

export const FETCH_USER_GROUPS_REQUEST = 'FETCH_USER_GROUPS_REQUEST';
export const FETCH_USER_GROUPS_SUCCESS = 'FETCH_USER_GROUPS_SUCCESS';
export const FETCH_USER_GROUPS_FAILED = 'FETCH_USER_GROUPS_FAILED';

export const FETCH_ADD_USER_GROUPS_REQUEST = 'FETCH_ADD_USER_GROUPS_REQUEST';
export const FETCH_ADD_USER_GROUPS_SUCCESS = 'FETCH_ADD_USER_GROUPS_SUCCESS';
export const FETCH_ADD_USER_GROUPS_FAILED = 'FETCH_ADD_USER_GROUPS_FAILED';

export const FETCH_DELETE_USER_GROUPS_REQUEST = 'FETCH_DELETE_USER_GROUPS_REQUEST';
export const FETCH_DELETE_USER_GROUPS_SUCCESS = 'FETCH_DELETE_USER_GROUPS_SUCCESS';
export const FETCH_DELETE_USER_GROUPS_FAILED = 'FETCH_DELETE_USER_GROUPS_FAILED';

export const RESET_ADD_USER_VEHICLE_GROUPS_SUCCESS = 'RESET_ADD_USER_VEHICLE_GROUPS_SUCCESS';

export const FETCH_ACCOUNT_BROKERS_REQUEST = 'FETCH_ACCOUNT_BROKERS_REQUEST';
export const FETCH_ACCOUNT_BROKERS_SUCCESS = 'FETCH_ACCOUNT_BROKERS_SUCCESS';
export const FETCH_ACCOUNT_BROKERS_FAILED = 'FETCH_ACCOUNT_BROKERS_FAILED';

export const FETCH_DELETION_USER_REQUEST = 'FETCH_DELETION_USER_REQUEST';
export const FETCH_DELETION_USER_SUCCESS = 'FETCH_DELETION_USER_SUCCESS';
export const FETCH_DELETION_USER_FAILED = 'FETCH_DELETION_USER_FAILED';
export const RESET_DELETION_USER_SUCCESS = 'RESET_DELETION_USER_SUCCESS';